var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGargantua(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10132_25284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.665 9.99996C18.665 14.7855 14.7855 18.665 9.99996 18.665C5.21441 18.665 1.33496 14.7855 1.33496 9.99996C1.33496 5.21441 5.21441 1.33496 9.99996 1.33496C14.7855 1.33496 18.665 5.21441 18.665 9.99996Z",
    stroke: "#E1E2E4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 5,
    fill: "url(#paint0_linear_10132_25284)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10132_25284",
    x1: 15,
    y1: 10,
    x2: 5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CD1E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F71CFE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10132_25284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGargantua);
export default __webpack_public_path__ + "static/media/gargantua.784698b6c800894943afc3e34e8fcccd.svg";
export { ForwardRef as ReactComponent };